// Indice do Perfil. Eram 13 secoes empilhadas numa pagina longa, com senha e
// sessoes no fim; o indice fixo no topo leva direto a cada uma, e as secoes
// ficam em tres blocos: Eu, Trabalho e Seguranca.
export const PROFILE_SECTION_GROUPS = [
  { id: 'me', sections: ['details', 'appearance', 'menu'] },
  { id: 'work', sections: ['signature', 'send', 'notifications'] },
  { id: 'security', sections: ['password', 'mfa', 'sessions', 'token'] },
];

export const profileAnchor = section => `profile-${section}`;

// Secao que nao aparece para a pessoa (senha com perfil travado, dois fatores
// desligado, notificacoes sem permissao) tambem sai do indice: link para uma
// ancora que nao existe nao leva a lugar nenhum.
export const profileIndex = ({
  canChangePassword = true,
  isMfaEnabled = false,
  canSeeNotifications = true,
} = {}) => {
  const hidden = new Set([
    ...(canChangePassword ? [] : ['password']),
    ...(isMfaEnabled ? [] : ['mfa']),
    ...(canSeeNotifications ? [] : ['notifications']),
  ]);
  return PROFILE_SECTION_GROUPS.map(group => ({
    id: group.id,
    sections: group.sections
      .filter(section => !hidden.has(section))
      .map(section => ({ id: section, anchor: profileAnchor(section) })),
  }));
};
